import Colors from "../../../theme/colors";

const style = {
  container: {
    backgroundColor: Colors.white,
    borderRadius: "8px",
    height: "100",
  },
  search: {
    display: "flex",
    alignItems: "center",
    gap: "20px",
  },
  searchInput: {
    width: "50%",
    border: "none",
  },
  tableContainer: {
    // marginTop: "3rem",
  },
  tableTitle: {
    color: Colors.mediumBlack,
    fontSize: "1.2rem",
    fontWeight: 500,
  },
  tableInfo: {
    fontSize: "1rem",
  },
  export: {
    display: "flex",
    width: "100%",
    justifyContent: "flex-end",
    marginBottom: "0.5rem",
  },
  tableHeading: {
    display: "flex",
    width: "100%",
    justifyContent: "space-between",
    marginBottom: "0.5rem",
  },
  tableHeadCells: {
    // padding: "8px",
    color: "#000000",
    fontWeight: 600,
    background: "#BAD9EC",
  },
  subTitle: {
    fontWeight: "400",
    fontSize: "8px",
    lineHeight: "20px",
    color: "#171B5E",
  },
  infoLabel: {
    px: "16px",
    py: "4px",
    mr: "12px",
    background: "#F2F2F2",
    borderRadius: "3px",
  },
  TableTitle: {
    fontWeight: "500",
    fontSize: "18px",
    lineHeight: "21px",
    color: "#616161",
    mb: "10px",
    mt: "23px",
  },
  doubleArrow: {
    backgroundColor: "#CDCBCD",
    width: "30px",
    height: "30px",
    borderRadius: "2px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#FFF",
    mx: "6px",
  },
  singleArrow: {
    backgroundColor: "#171B5E",
    width: "30px",
    height: "30px",
    borderRadius: "2px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#FFF",
    mx: "6px",
  },
  actionBtn: {
    borderRadius: 0,
    fontSize: 12,
    color: "#FB5C5F",
    backgroundColor: "rgb(242, 242, 242)",
    padding: "2px 8px",
  },
  actionButtons: {
    display: "flex",
    gap: 22,
  },
  actionIcon: {
    cursor: "pointer",
  },
  pagination: {
    display: "flex",
    justifyContent: "center",
    margin: "20px 0",
  },
  left: {
    display: "flex",
    gap: "1rem",
  },
  emptyContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: 400,
  },
  noDataMsg: {
    color: "#515772",
  },

  buttonStyle: {
    marginTop: "16px",
    gap: 2,
  },

  popup: {
    position: "absolute",
    top: "0px",
    left: "0px",
    transform: "translate(-50%, -50%)",
    width: 455,
    backgroundColor: "#FFFFFF",
    borderRadius: "10px",
    boxShadow: 24,
    padding: "30px",
  },
  typeLabel: {
    marginRight: "5px",
    fontSize: "18px",
    fontWeight: "bold",
    color: "#ff7f00",
  },
};

export default style;
